export const graphqlApiRequest = async (url, query, variables) => {
  const req_body = {
    query,
    variables
  };
  const token = localStorage.getItem('token');

  const fetchOpts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-source': 'ams',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(req_body)
  };

  try {
    const response = await fetch(url, fetchOpts);
    return await response.json();
  } catch (error) {
    if (error.message === 'Failed to fetch') {
      throw new Error(
        'Internet connection is not stable, Please check and try in sometimes again.'
      );
    } else {
      throw new Error(`An error occurred. Please retry again ${error}`);
    }
  }
};
